export default __webpack_public_path__ + "static/media/Echoes from the Beyond.30796603.png";